module.exports = __webpack_public_path__ + "createstatic/media/upload-icon.051d111c.svg";